/** A successful policy read found no approved calculation configuration. */
export class ResultPolicyRequiredError extends Error {
  constructor() { super("Result policy approval is required"); }
}
